import React from 'react';
import SummaryCard from '../components/summary_card/View';

const IdeaSummaryCard = ({ ownerPhoto,isHackathonEnable,ownerName, visits, published, businessUnit, market, categoryName,onUserClick ,ownerEmail}) => (
  <SummaryCard
    ownerPhoto={ownerPhoto}
    ideaOwnerName={ownerName}
    ownerEmail={ownerEmail}
    onIdeaOwnerUserClick={onUserClick}
    MyIdeaView={visits}
    createdDate={published}
    businessUnit={businessUnit}
    market={market}
    CategoryName={categoryName || 'N/A'}
    onClickUserProfile={() => {}}
    isHackathonEnable={isHackathonEnable}
  />
);

export default IdeaSummaryCard;
